// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2eBS4","tab":"ProcedureTabs_tab__faXJP"};